//deps
import styled, { css, keyframes } from "styled-components";
import { isEmpty } from "@swiggy-private/js-utils";
import { TOING_HEADER_BANNER_SLIDE_UP_CLIP_WINDOW_MS } from "@swiggy-private/cart-ui";
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";

export const HeaderContainer = styled.div<{ $isRtbXpEnabled?: boolean }>`
    width: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
    height: ${(props) => (props.$isRtbXpEnabled ? "15vh" : "100%")};
    overflow: hidden;
`;

export const HeaderContentWrapper = styled.div<{
    $isRtbXpEnabled?: boolean;
    restaurantName?: string;
    isCartError?: boolean;
    isEmptyCart?: boolean;
    $isAnimationInProgress?: boolean;
}>`
    display: flex;
    width: 100%;
    height: 100%;
    position: static;
    z-index: ${(props) => props.$isRtbXpEnabled && 9};
    padding: ${(props) => props.theme.spacing.medium} 0 ${(props) => props.theme.spacing.small};
    background-color: ${(props) =>
        isEmpty(props.restaurantName) && !props.isCartError && !props.isEmptyCart
            ? props.theme.colors[props.theme.colorMode].background_Secondary
            : "transparent"};
    pointer-events: ${({ $isAnimationInProgress }) => ($isAnimationInProgress ? "none" : "auto")};
    ${({ $isRtbXpEnabled }) =>
        $isRtbXpEnabled &&
        css`
            padding-top: 0;
        `};
`;

export const IconContainer = styled.div<{
    $isAnimationInProgress?: boolean;
}>`
    padding: 0 ${(props) => props.theme.spacing.small} 0 ${(props) => props.theme.spacing.medium};
    margin-left: -1px;
    z-index: 400;
    display: flex;
    align-items: center;
    pointer-events: ${({ $isAnimationInProgress }) => ($isAnimationInProgress ? "none" : "auto")};
`;

export const HeaderBannerWrapper = styled.div<{ $isHidden?: boolean }>(({ theme, $isHidden }) => ({
    padding: `0 ${theme.spacing.medium}`,
    height: $isHidden ? 0 : "100px",
    visibility: $isHidden ? "hidden" : "visible",
}));

export const ToingStatusBarStampContainer = styled.div({
    position: "fixed",
    top: "20px",
    right: "23px",
    width: "120px",
    height: "128px",
    zIndex: 0,
    pointerEvents: "none",
    transform: "translate(20%, -15%)",
});

export const ToingStatusBarStampImage = styled(Image)({
    width: "100%",
    height: "100%",
    objectFit: "unset",
});

export const ToingHeaderLottieContainer = styled.div({
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    zIndex: 10,
    pointerEvents: "none",
});

export const popIn = keyframes`
    0% {
        opacity: 0;
        transform: scale(0.35);
    }
    65% {
        opacity: 1;
        transform: scale(1.08);
    }
    100% {
        transform: scale(1);
    }
`;
export const POP_IN_DURATION_MS = 480;

export const FloatingButtonWrap = styled.button<{ $animate: boolean }>`
    position: absolute;
    bottom: -26px;
    right: 10px;
    z-index: 2;
    transform-origin: bottom;
    border: none;
    padding: 0;
    -webkit-tap-highlight-color: transparent;
    touch-action: manipulation;
    user-select: none;
    transition:
        transform 0.12s ease,
        filter 0.12s ease;
    cursor: pointer;
    background: transparent;
    ${({ $animate }) =>
        $animate
            ? css`
                  animation: ${popIn} ${POP_IN_DURATION_MS}ms cubic-bezier(0.33, 1, 0.68, 1)
                      ${TOING_HEADER_BANNER_SLIDE_UP_CLIP_WINDOW_MS}ms both;
              `
            : css`
                  animation: none;
              `}
    @media (hover: hover) {
        &:hover {
            transform: scale(0.95, 0.95);
            transition: all 0.1s ease-in;
        }
    }

    &:active {
        transform: scale(0.95, 0.95);
        transition: all 0.1s ease-in;
`;

export const ToingRtbSavingsBannerSpacer = styled.div(({ theme }) => ({
    width: "100%",
    flexShrink: 0,
    pointerEvents: "none",
    visibility: "hidden",
    padding: `${theme.spacing.xxSmall} 0`,
    marginBottom: theme.spacing.medium,
    lineHeight: "16px",
    "&::before": {
        content: '"\\00a0"',
        display: "block",
    },
}));
